import { useEffect,  useRef, useState, useContext } from "react";
import { LineSeries, AreaSeries, CandlestickSeries, BarSeries, BaselineSeries, HistogramSeries } from "lightweight-charts-react-wrapper";
import { ChartContext } from "../../../store/ChartContext";
import { createWebsocketConnection } from "../../../api/indicatorEngineApi";
import Legend from "./Legend";
import { INITIAL_CANDLES } from "../../../env";
import NotificationHandler from "./NotificationHandler";
import SignalAudioPlayer from '../../SignalAudioPlayer';

export default function Series({ chart }) {
    /* Responsible for displaying the chart series. Handles websockets creation, handling incoming data */
    const socket = useRef(null);  
    const [reconnectAttempts, setReconnectAttempts] = useState(0); 
    const reconnectAttemptsRef = useRef(reconnectAttempts);
    const watchdogTimer = useRef(null);
    const [watchdog, setWatchdog] = useState(true);
    const seriesRef = useRef(null);
    const seriesEma1Ref = useRef(null);
    const seriesEma2Ref = useRef(null);
    const seriesEma3Ref = useRef(null);
    const seriesEma4Ref = useRef(null);
    const seriesRegHighRef = useRef(null);
    const seriesAreaUpRef = useRef(null);
    const seriesAreaDownRef = useRef(null);
    const seriesRegMiddleRef = useRef(null);
    const seriesRegLowRef = useRef(null);
    const seriesZoneUpRef = useRef(null);
    const seriesZoneDownRef = useRef(null);
    const [data, setData] = useState([]);
    const [markers, setMarkers] = useState([]);
    const [currentTrandMarker, setCurrentTrandMarker] = useState(null);
    const [countMarkers, setCountMarkers] = useState(0);
    const [countDisplay, setCountDisplay] = useState(1);
    const [errorMessage, setErrorMessage] = useState(null);
    const prevGranularity = useRef(0);
    const prevBarTimeRef = useRef(0);
    const [notificationTriggerKey, setNotificationTriggerKey] = useState(0);
   
    const {
        instrument,
        granularity,
        seriesType,
        virtualAssistantSettings,
        isSoundEnabled,
    } = useContext(ChartContext);
    const MAX_RECONNECT_ATTEMPTS = 10;
    const MAX_RECONNECT_DELAY = 60000;

    const [ema1Data, setEma1Data] = useState([]);
    const [ema2Data, setEma2Data] = useState([]);
    const [ema3Data, setEma3Data] = useState([]);
    const [ema4Data, setEma4Data] = useState([]);  

    const [regHighData, setRegHighData] = useState([]);
    const [regMiddleData, setRegMiddleData] = useState([]);
    const [regLowData, setRegLowData] = useState([]); 

    const [regZoneUpData, setRegZoneUpData] = useState([]);
    const [regZoneDownData, setRegZoneDownData] = useState([]);

    const regSeriesOptions = {
        color: "red",
        lineWidth: 2,
        lineStyle: 1,    
        priceLineVisible: false, 
        lastValueVisible: false
    };

    const regZoneSeriesOptions = {
        color: "red",
        lineWidth: 1,
        lineStyle: 1,    
        priceLineVisible: false, 
        lastValueVisible: false
    };

    const emaSeriesOptions = {
        lineWidth: 2, 
        priceLineVisible: false, 
        lastValueVisible: false
    };
    
    const seriesVariants = {
        "line": LineSeries,
        "area": AreaSeries,
        "candlestick": CandlestickSeries,
        "bar": BarSeries,
        "baseline": BaselineSeries,
        "histogram": HistogramSeries
    }
    let SelectedSeries = seriesVariants[seriesType];

    const [notificationData, setNotificationData] = useState({
        newTitle: "",
        message: "",
      });
    
    const [signalDetected, setSignalDetected] = useState(false);

    const generateSoundSignal = () => {
        setSignalDetected(true);
        setTimeout(() => setSignalDetected(false), 2000);
    };
    

/////////////////EMA with SMA
/*
    useEffect(() => {
        const calculateEMA = (data, period) => {
            const result = [];
            const ema = [];
            const smoothingFactor = 2 / (period + 1);
           
            if (data.length < period) 
               return result;       
        
            //Calculate the SMA for the first period
            let sma = 0;
            for (let i = 0; i < period; i++) {
                sma += data[i].close;
            }
            sma /= period;
        
            //Set the SMA as the first EMA point.
            ema[period - 1] = sma;
            result.push({ time: data[period - 1].time, value: sma });
        
            //Calculate the EMA for the remaining data.
            for (let i = period; i < data.length; i++) {
                ema[i] = (data[i].close * smoothingFactor) + (ema[i - 1] * (1 - smoothingFactor));
                result.push({ time:data[i].time, value: ema[i] });
            }
        
            return result;
        };

        // Calculate EMA when data changes
        if (virtualAssistantSettings.ema){
            if (data.length) 
                setEma11Data(calculateEMA(data,  virtualAssistantSettings.emaPeriod1));
        }
        else
            setEma11Data([]);
    }, [data, virtualAssistantSettings]);


    useEffect(() => {
        // Set EMA data to the series
        if (ema11Data.length > 0) {
            try {
                seriesEma11Ref.current.setData(ema11Data);
            } catch (e) {
                console.error("Error in setting EMA data to series", e);
            }
        }
    }, [ema11Data]);
*/
    /////////////////EMA without SMA

    useEffect(() => {
        const calculateEMA = (data, period) => {
            const result = [];
            const ema = [];
            const smoothingFactor = 2 / (period + 1);
           
            if (data.length < period) 
               return result;             
        
            ema[0] = data[0].close;
            result.push({ time: data[0].time, value: data[0].close });
        
            //Calculate the EMA for the remaining data.
            for (let i = 1; i < data.length; i++) {
                ema[i] = (data[i].close * smoothingFactor) + (ema[i - 1] * (1 - smoothingFactor));
                result.push({ time:data[i].time, value: ema[i] });
            }
        
            return result;
        };

        // Calculate EMA when data changes
        if (virtualAssistantSettings.ema)
            if (data.length){ 
                setEma1Data(calculateEMA(data,  virtualAssistantSettings.emaPeriod1));
                setEma2Data(calculateEMA(data,  virtualAssistantSettings.emaPeriod2));
                setEma3Data(calculateEMA(data,  virtualAssistantSettings.emaPeriod3));
                setEma4Data(calculateEMA(data,  virtualAssistantSettings.emaPeriod4));
            }
        
    }, [data, virtualAssistantSettings]);


    useEffect(() => {
        // Set EMA data to the series
        if (seriesEma1Ref.current) {
            try {
                seriesEma1Ref.current?.setData([]);
                seriesEma1Ref.current?.setData(ema1Data);
            } catch (e) {
                console.error("Error in setting EMA data to series", e);
            }
        }
    }, [ema1Data]);

    useEffect(() => {
        // Set EMA data to the series
        if ( seriesEma2Ref.current) {
            try {
                seriesEma2Ref.current?.setData([]);
                seriesEma2Ref.current?.setData(ema2Data);
            } catch (e) {
                console.error("Error in setting EMA data to series", e);
            }
        }
    }, [ema2Data]);

    useEffect(() => {
        // Set EMA data to the series
        if (seriesEma3Ref.current) {
            try {
                seriesEma3Ref.current?.setData([]);
                seriesEma3Ref.current?.setData(ema3Data);
            } catch (e) {
                console.error("Error in setting EMA data to series", e);
            }
        }
    }, [ema3Data]);

    useEffect(() => {
        // Set EMA data to the series
        if (seriesEma4Ref.current) {
            try {
                seriesEma4Ref.current?.setData([]);
                seriesEma4Ref.current?.setData(ema4Data);
            } catch (e) {
                console.error("Error in setting EMA data to series", e);
            }
        }
    }, [ema4Data]);

    useEffect(() => {
        if (seriesRegHighRef.current)
            try {
                seriesRegHighRef.current.setData(regHighData);
            } catch (e) {
                console.error("Error in setting regresion channel data to series", e);
            }
    }, [regHighData]);

    useEffect(() => {
        if (seriesZoneUpRef.current)
            try {
                    const result = [];
                    var value = 0;
                    for (let i = 0; i < regHighData.length; i++) {
                        value = (regHighData[i].value -  (regHighData[i].value - regMiddleData[i].value) * (virtualAssistantSettings.channelZone / 100));
                        result.push({ time:regHighData[i].time, value: value });
                    }
                    setRegZoneUpData(result)
                    seriesZoneUpRef.current.setData(result);
            } catch (e) {
                console.error("Error in setting regresion channel data to series (RegZoneUpData)", e);
            }
    }, [regHighData, regMiddleData, virtualAssistantSettings.channelZone]);

    useEffect(() => {
        if (seriesRegMiddleRef.current)
            try {
                seriesRegMiddleRef.current.setData(regMiddleData);
            } catch (e) {
                console.error("Error in setting regresion channel data to series", e);
            }
        if (seriesAreaUpRef.current)
            try {
                seriesAreaUpRef.current.setData(regMiddleData);
            } catch (e) {
                console.error("Error in setting regresion channel data to series (AreaUp)", e);
            }

        if (seriesAreaDownRef.current)
            try {
                seriesAreaDownRef.current.setData(regMiddleData);
            } catch (e) {
                console.error("Error in setting regresion channel data to series (AreaDown)", e);
            }
    }, [regMiddleData]);

    useEffect(() => {
        if (seriesRegLowRef.current)
            try {
                seriesRegLowRef.current.setData(regLowData);
            } catch (e) {
                console.error("Error in setting regresion channel data to series", e);
            }
    }, [regLowData]);

    useEffect(() => {
        if (seriesZoneDownRef.current)
            try {
                    const result = [];
                    var value = 0;
                    for (let i = 0; i < regLowData.length; i++) {
                        value = (regLowData[i].value + (regMiddleData[i].value - regLowData[i].value) * (virtualAssistantSettings.channelZone / 100));
                        result.push({ time:regLowData[i].time, value: value });
                    }
                    setRegZoneDownData(result)
                    seriesZoneDownRef.current.setData(result);
            } catch (e) {
                console.error("Error in setting regresion channel data to series (RegZoneDownData)", e);
            }
    }, [regLowData, regMiddleData, virtualAssistantSettings.channelZone]);

    useEffect(() => {
        //Set series data on incoming data
        if (seriesRef.current)
        try {
            seriesRef.current?.setData([])
            seriesRef.current?.setData(data)
        } catch (e) {
            console.log("Error in setting data in series")
            console.log(e);
        }
    }, [data]);


    useEffect(() => {
        const triggerNotification = (message, count, marker) => {

            if (typeof Notification == "undefined")
                return;

            let zone = "";
            if (regZoneUpData.length > 0 && regZoneDownData.length > 0 && marker) {

                const dataPoint = data.find(d => d.time === marker.time);
                const zoneUpPoint = regZoneUpData.find(d => d.time === marker.time);
                const zoneDownPoint = regZoneDownData.find(d => d.time === marker.time);
                const highPoint = regHighData.find(d => d.time === marker.time);
                const lowPoint = regLowData.find(d => d.time === marker.time);

                if (dataPoint && zoneUpPoint && zoneDownPoint && highPoint && lowPoint) {
                    const closePrice = dataPoint.close;

                    if (closePrice > highPoint.value) {
                        zone = "above channel";
                    } else if (closePrice > zoneUpPoint.value) {
                        zone = "upper zone";
                    } else if (closePrice > zoneDownPoint.value) {
                        zone = "middle zone";
                    } else if (closePrice > lowPoint.value) {
                        zone = "lower zone";
                    } else {
                        zone = "below channel";
                    }
                }
            }

            const zoneInfo = zone ? ` Signal in ${zone}.` : "";

            setNotificationData({
                newTitle: "🔔" + instrument.display_name,
                message: message + zoneInfo,
                count: count
            });
        };

        //Set series markers on incoming markers
        if (seriesRef.current) {
            try {
                seriesRef.current.setMarkers(markers);
                if (markers.length > 0) {
                    if (countMarkers === 0) {
                        setCountMarkers(markers.length);
                    } else if ((countMarkers !== markers.length) && (notificationTriggerKey > 0))  {
                        if (countMarkers < markers.length) {
                            const latestMarker = markers[markers.length - 1];
                            const shouldNotify =
                                (virtualAssistantSettings.notificationTriggerState === 'open') ||
                                (virtualAssistantSettings.notificationTriggerState === 'close' && prevBarTimeRef.current == latestMarker.time);

                            if (shouldNotify) {
                                console.log("Should notify: true");
                                if (isSoundEnabled)
                                    generateSoundSignal();

                                triggerNotification(`Signal for the instrument ${instrument.display_name}.`, countDisplay, latestMarker);
                                setCountDisplay(countDisplay + 1);
                                setCountMarkers(markers.length);
                            } else {
                                console.log("Should notify: false");
                            }
                        }
                        
                    }
                }
            } catch (e) {
                console.log("Error in setting data in series (markers)")
                console.log(e);
            }
        }
    }, [markers, currentTrandMarker, instrument, isSoundEnabled, notificationTriggerKey]);


    useEffect(() => {

        const resetWatchdog = () => {
            if (watchdogTimer.current) {
                clearTimeout(watchdogTimer.current);
            }
           
            watchdogTimer.current = setTimeout(() => {
                setWatchdog(watchdog => !watchdog);
            }, 60000);           
        };

        const createAndConfigureWS = () => {   
            socket.current = createWebsocketConnection();

            if (prevGranularity.current !== granularity.value)              
               virtualAssistantSettings.channelTimeframe = granularity.value;         
             
            prevGranularity.current = granularity.value;
        
            socket.current.onopen = () => {
                setReconnectAttempts(0);
                setErrorMessage(null);
                const to_date = Math.floor(Date.now() / 1000);
                const from_date = to_date - (granularity.value * INITIAL_CANDLES);
                socket.current.send(JSON.stringify({
                    "type": "configure", data: {
                        "virtual_assistant": virtualAssistantSettings.on,
                        "ema_period_1": parseInt(virtualAssistantSettings.emaPeriod1, 10),
                        "ema_period_2": parseInt(virtualAssistantSettings.emaPeriod2, 10),
                        "ema_period_3": parseInt(virtualAssistantSettings.emaPeriod3, 10),
                        "ema_period_4": parseInt(virtualAssistantSettings.emaPeriod4, 10),
                        "sensitivity": parseInt(virtualAssistantSettings.sensitivity, 10),
                        "length": parseInt(virtualAssistantSettings.length, 10),
                        "channel": virtualAssistantSettings.channel,
                        "channel_background": virtualAssistantSettings.channelBackground,                        
                        "channel_bars": parseInt(virtualAssistantSettings.channelBars, 10),
                        "channel_timeframe": parseInt(virtualAssistantSettings.channelTimeframe, 10),  
                        "instrument": instrument.name,
                        "precision": instrument.precision,
                        "instrument_point": instrument.pip_value,
                        "granularity": parseInt(granularity.value, 10),
                        "from_date": from_date,
                        "to_date": to_date
                    }
                }))
            };
        }

        const roundToPrecision = (number) => {
            const factor = Math.pow(10, instrument.precision);
            return parseFloat((Math.round(number * factor) / factor).toFixed(instrument.precision));
        }

        const convertToHeikinAshi = (ohlcData) => {
            if (!ohlcData || ohlcData.length === 0) return [];
          
            const heikinAshiData = [];
          
            for (let i = 0; i < ohlcData.length; i++) {
                const { open, high, low, close } = ohlcData[i];
          
                const haClose = roundToPrecision((open + high + low + close) / 4);
                let haOpen;
                if (i === 0) 
                    haOpen = roundToPrecision((open + close) / 2);
                else 
                    haOpen = roundToPrecision((heikinAshiData[i - 1].open + heikinAshiData[i - 1].close) / 2);
                  
                const haHigh = roundToPrecision(Math.max(high, haOpen, haClose));
                const haLow = roundToPrecision(Math.min(low, haOpen, haClose));

                heikinAshiData.push({
                    time: ohlcData[i].time,
                    open: haOpen,
                    high: haHigh,
                    low: haLow,
                    close: haClose,
                    value: ohlcData[i].value,
                });
            }
          
            return heikinAshiData;
          };      
          
          const convertCandleToHeikinAshi = (prevCandle, currentCandle) => {        
                const haClose = roundToPrecision((currentCandle.open + currentCandle.high + currentCandle.low + currentCandle.close) / 4);
                const haOpen = roundToPrecision((prevCandle.open + prevCandle.close) / 2);                  
                const haHigh = roundToPrecision(Math.max(currentCandle.high, haOpen, haClose));
                const haLow = roundToPrecision(Math.min(currentCandle.low, haOpen, haClose));

                currentCandle.open = haOpen;
                currentCandle.high = haHigh;
                currentCandle.low = haLow;
                currentCandle.close = haClose;

                return currentCandle;
          };      
    
        const handleOHLCData = (OHLCdata) => {
            let dataPoint;
            try {
                dataPoint = JSON.parse(OHLCdata);
                if (virtualAssistantSettings.on) {
                    const color = "#5d5d5d";
                    dataPoint["color"] = color;
                    dataPoint["wickColor"] = color;
                    dataPoint["borderColor"] = color;
                }
                if (dataPoint.time === undefined) {
                    return;
                }
            } catch (e) {
                console.log("Error in parsing data from websocket");
                console.log(e);
                return;
            }
            
            setData(prevData => {
                /* Handling out of order or candle update data */
                if (prevData.length && prevData[prevData.length - 1].time > dataPoint.time) {
                    console.log("Data is not in order");
                    console.log("Datapoint has wrong time: ", dataPoint.time);
                    console.log("Last data point time: ", prevData[prevData.length - 1].time);
                    return prevData;
                }
                if (!prevData || prevData.length === 0) {
                    return [dataPoint];
                }
               
                if (prevData.length >= 2 && prevData[prevData.length - 1].time === dataPoint.time) {
                    dataPoint = convertCandleToHeikinAshi(prevData[prevData.length - 2], dataPoint);
                    return [...prevData.slice(0, -1), dataPoint];
                }

                dataPoint = convertCandleToHeikinAshi(prevData[prevData.length - 1], dataPoint);
                prevBarTimeRef.current = prevData[prevData.length - 1].time;
                setNotificationTriggerKey(prev => prev + 1);
                return [...prevData, dataPoint];
            });
          }
    
        const handleVAData = (response) => {
            setData(prevData => {
                for (let i = 0; i < Object.keys(response["snapshot"]).length; i++) {
                    const dataPoint = prevData.find(dataPoint => dataPoint.time === response["time"][i]);
                    if (dataPoint) {
                        let color = "#5d5d5d";
                        if (response["snapshot"][i] === 1) color = "#1E90FF";
                        if (response["snapshot"][i] === -1) color = "#ff2c2c";
                        dataPoint["color"] = color;
                        dataPoint["wickColor"] = color;
                        dataPoint["borderColor"] = color;
                    }
                }
                return [...prevData];
            });
    
            setMarkers(prevMarkers => {
                let markers = [];
                for (let i = Object.keys(response["arrow_up"]).length - 1; i >= 0; i--) {
                    if (response["arrow_up"][i] !== 0) {
                        markers.push({ time: response["time"][i], position: "belowBar", shape: "arrowUp", color: "#1E90FF" });
                    }
                    if (response["arrow_down"][i] !== 0) {
                        markers.push({ time: response["time"][i], position: "aboveBar", shape: "arrowDown", color: "#ff2c2c" });
                    }
                }
                markers.reverse();
                return markers;
            });
        }
    
        const handleCandlesMore = (fetchedData) =>{
            if (virtualAssistantSettings.on) {
                for (let dataPoint of fetchedData) {
                    const color = "#5d5d5d";
                    dataPoint["color"] = color;
                    dataPoint["wickColor"] = color;
                    dataPoint["borderColor"] = color;
                }
            }
            setData(prevData => {
                return [...fetchedData, ...prevData]
            });
        } 

        setMarkers([]);
        setCurrentTrandMarker(null);
        setData([]);
        setEma1Data([]);
        setEma2Data([]);
        setEma3Data([]);
        setEma4Data([]);
        setRegHighData([]);
        setRegMiddleData([]);
        setRegLowData([]);
        if (! socket.current)
            createAndConfigureWS();
        
        if (!virtualAssistantSettings.on) 
            setMarkers([]);
    
        socket.current.onmessage = (event) => {
            resetWatchdog();
            let response;
            try {
                response = JSON.parse(event.data);
            } catch (e) {
                console.error("Data parsing error:", e);
                return;
            }
          
            // Data structure validation
            if (!response.type || !response.data) {
              console.error("Invalid data format:", response);
              return;
            }

            switch (response.type) {
                case "candles":
                    setData(convertToHeikinAshi(response.data));
                    break;
                case "OHLCdata":
                    handleOHLCData(response.data);
                    break;
                case "va":
                    handleVAData(response.data);
                    break;
                case "candlesMore":
                    handleCandlesMore(response.data)
                    break;
                case "channel":
                    setRegHighData(response.data.high)
                    setRegMiddleData(response.data.middle)
                    setRegLowData(response.data.low)
                    break;
                case "ping":
                    socket.current.send(JSON.stringify({ "type": "pong" }));
                    break;
                default:
                    console.warn("Unknown message type:", response.type);
              }
        };
    
        socket.current.onclose = (event) => {
            console.log("WebSocket connection closed:", event);
          
           if (!event.wasClean) {
            // "Unexpected closure – attempting to reconnect
              setErrorMessage("The connection was interrupted. Reconnecting...");
              setTimeout(() => {
                    setWatchdog(watchdog => !watchdog);
              }, 5000);
            } 
          };
    
        socket.current.onerror = (error) => {
            console.error("WebSocket error:", error);
            if (reconnectAttemptsRef.current < MAX_RECONNECT_ATTEMPTS) {
              const delay = Math.min(1000 * 2 ** reconnectAttemptsRef.current, MAX_RECONNECT_DELAY);
              setErrorMessage("The connection was interrupted. Reconnecting...");
              setTimeout(() => {
                    setReconnectAttempts((prev) => prev + 1);
                    setWatchdog(watchdog => !watchdog);
              }, delay);
            } else {
                setErrorMessage("Failed to reconnect. Please try again later.");
            }
          };
    
        return () => {
            if (socket.current && socket.current.readyState !== WebSocket.CLOSED) {
                socket.current.close(1000);
                socket.current = null;
            }
            if (watchdogTimer.current) {
                clearTimeout(watchdogTimer.current);
            }
        };
      }, [watchdog, instrument, granularity, virtualAssistantSettings]);
    

/* Temporarily commented out, this functionality will likely be removed.
 useEffect(() => {
        //Handle left scrolling of the chart - loading historical data
        const timeScale = chart.current.timeScale();
        let timer = null;
       
        function handleSubscribeVisibleTimeRangeChange() {
            if (timer !== null) {
                return;
            }
            timer = setTimeout(() => {
                try {
                const logicalRange = timeScale.getVisibleLogicalRange();
                if (logicalRange !== null) {
                    const barsInfo = seriesRef.current.barsInLogicalRange(logicalRange);
                    if (barsInfo !== null && barsInfo.barsBefore < -10) { //if there are less than 10 bars before visible range, we should fetch more historical data.
                        const to_date = barsInfo.from - granularity.value;
                        const from_date = to_date - (granularity.value * Math.floor(Math.abs(barsInfo.barsBefore)));
                        if ((to_date - from_date) / granularity.value < 100) {
                            socket.current.send(JSON.stringify({
                                "type": "moreOHLCdata", data: {                                 
                                    "from_date": from_date,
                                    "to_date": to_date
                                }
                            }))
                        }
                    }
                }
                timer = null;
                } catch (e) {
                    console.log("Error in handleSubscribeVisibleTimeRangeChange");
                    console.log(e);
                }
            }, 1000);
        }

        timeScale.subscribeVisibleTimeRangeChange(handleSubscribeVisibleTimeRangeChange);

        return () => {
            timeScale.unsubscribeVisibleTimeRangeChange(handleSubscribeVisibleTimeRangeChange);
        }
    }, [chart, granularity]);
*/
    useEffect(() => {
        reconnectAttemptsRef.current = reconnectAttempts;
    }, [reconnectAttempts]);

    const [areaStartColor, setAreaStartColor] = useState("rgba(0,0,0,0)");
    const [areaEndColor, setAreaEndColor] = useState("rgba(0,0,0,0)");

    useEffect(() => {
        if (regMiddleData.length > 0) {
            // Get first and last values to determine trend direction
            const firstValue = regMiddleData[0]?.value;
            const lastValue = regMiddleData[regMiddleData.length - 1]?.value;

            // Determine colors based on trend direction
            if (firstValue > lastValue) {
                setAreaStartColor("rgba(255, 0, 0, .3)");
                setAreaEndColor("rgba(255, 0, 0, .3)");
            } else {
                setAreaStartColor("rgba(0, 123, 255, .3)");
                setAreaEndColor("rgba(0, 123, 255, .3)");
            }
        }
    }, [regMiddleData]);

    return (
        <>
            <NotificationHandler newTitle={notificationData.newTitle} message={notificationData.message} count={notificationData.count} />

           {errorMessage && (
                <div className="error-message">
                    {errorMessage}
                </div>
            )}
            <Legend chart={chart} seriesType={seriesType} instrument={instrument} series={seriesRef} />
            <SelectedSeries data={data} ref={seriesRef}  priceFormat={{ type: 'price', precision: instrument.precision, minMove: 0.00001 }} />

            {virtualAssistantSettings.channelBackground && (
                <AreaSeries
                    data={regMiddleData}
                    ref={seriesAreaUpRef}
                    topColor={areaStartColor}
                    bottomColor={areaEndColor}
                    lineVisible={false}
                    invertFilledArea={true}
                    priceLineVisible={false}                    
                    lastValueVisible={false}
                />
            )}

            {virtualAssistantSettings.channelBackground && (
                <AreaSeries
                    data={regMiddleData}
                    ref={seriesAreaDownRef}
                    topColor={areaEndColor}
                    bottomColor={areaStartColor}
                    lineVisible={false}
                    priceLineVisible={false}
                    lastValueVisible={false}
                />
            )}
          
            {virtualAssistantSettings.channel && <LineSeries  data={regHighData} ref={seriesRegHighRef} {...regSeriesOptions} />}
            {virtualAssistantSettings.channel && <LineSeries  data={regZoneUpData} ref={seriesZoneUpRef} {...regZoneSeriesOptions} />}
            {virtualAssistantSettings.channel && <LineSeries data={regMiddleData} ref={seriesRegMiddleRef} {...regSeriesOptions} />}
            {virtualAssistantSettings.channel && <LineSeries  data={regZoneDownData} ref={seriesZoneDownRef} {...regZoneSeriesOptions} />}
            {virtualAssistantSettings.channel && <LineSeries data={regLowData} ref={seriesRegLowRef} {...regSeriesOptions} />}
        
            {virtualAssistantSettings.ema && <LineSeries data={ema1Data} ref={seriesEma1Ref} color={virtualAssistantSettings.emaColor1} {...emaSeriesOptions} /> }
            {virtualAssistantSettings.ema && <LineSeries data={ema2Data} ref={seriesEma2Ref} color={virtualAssistantSettings.emaColor2} {...emaSeriesOptions} /> }  
            {virtualAssistantSettings.ema && <LineSeries data={ema3Data} ref={seriesEma3Ref} color={virtualAssistantSettings.emaColor3} {...emaSeriesOptions} /> }   
            {virtualAssistantSettings.ema && <LineSeries data={ema4Data} ref={seriesEma4Ref} color={virtualAssistantSettings.emaColor4} {...emaSeriesOptions} /> }                 
       
            <SignalAudioPlayer signal={signalDetected} />
        </>
    )
}